module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"files:to-attach":"Прикрепить файл/файлы","files:upload-desc":"Перетяните файл/файлы в это поле или выберите вручную","create-object:notify-success":"Создание выполнено","create-object:notify-success-text":"Создание объекта выполнено успешно"}}')
  delete Component.options._Ctor
}
